import { type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";
import { inputVariants } from "./input-variants";

export interface InputProps
	extends Omit<
			React.InputHTMLAttributes<HTMLInputElement>,
			"size" | "fontWeight"
		>,
		VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, variant, fontWeight, size, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(inputVariants({ variant, fontWeight, size, className }))}
				ref={ref}
				{...props}
			/>
		);
	},
);
Input.displayName = "Input";

export { Input };
